export const getFullUrl = () => window.location.href;

export const getDomain = () => window.location.origin;

/**
 * Extracts query parameters from the current URL.
 * @returns {URLSearchParams} The URL query parameters.
 */
export const getUrlQueryParameters = () => new URLSearchParams(window.location.search);

export const extractQueryParameter = (queryParams, paramToExtract) =>
    queryParams.has(paramToExtract) ? { [paramToExtract]: queryParams.get(paramToExtract) } : null;

export const extractQueryParameters = (queryParams, paramsToExtract) => {
    const extractedParams = {};

    for (const key of paramsToExtract) {
        const param = extractQueryParameter(queryParams, key);

        if (param) extractedParams[key] = param[key];
    }

    return extractedParams;
};

export const setQueryParameters = (queryParams, paramsToSet) => {
    for (const [key, value] of Object.entries(paramsToSet)) {
        queryParams.set(key, value);
    }
};
